import { canBootstrapUip } from './can-bootstrap-uip';
import { bootstrapUip } from '../bootstrap-uip';

/**
 * Checks whether Top-menu could be bootstraped and bootstraps in case of true result.
 */
export const bootstrapUipIfPossible = async () => {
  if (!await canBootstrapUip()) {
    return;
  }

  bootstrapUip();
};
